<template>
    <div v-if="deltaValue">
      <v-progress-linear :absolute="absolute" :background-color="getBg" :color="getColor" rounded indeterminate></v-progress-linear>
    </div>
</template>

<script>
    export default {
      name: "highlightChange",
      props: ['deltaValue', 'absolute'],
      computed: {
        getBg(){
          return this.hasChanged() ? 'error lighten-3' : 'success lighten-3';
        },
        getColor(){
          return this.isRemoved() ? 'error lighten-1' : 'success lighten-1';
        }
      },
      mounted() {
        // console.log(this.deltaValue);
        // if (this.isNew()) console.log(this.deltaValue, 'is new');
        // if (this.hasChanged()) console.log(this.deltaValue, 'has changed');
      },
      methods: {
        isNew(){
          if (typeof this.deltaValue === 'undefined') {
            return false
          }

          if (Array.isArray(this.deltaValue)) {
            return this.deltaValue.length === 1;
          } else if (typeof this.deltaValue === 'object') {
            return this.deltaValue[Object.keys(this.deltaValue)[0]].length === 1;
          }

          return false;
        },
        hasChanged(){
          if (typeof this.deltaValue === 'undefined') {
            return false
          }

          // console.log(this.deltaValue);

          if (Array.isArray(this.deltaValue)) {
            return this.deltaValue.length === 2 && this.deltaValue[0] !== false && this.deltaValue[0] !== undefined && this.deltaValue[0] !== null;
          } else if (typeof this.deltaValue === 'object') {
            let v = this.deltaValue[Object.keys(this.deltaValue)[0]];
            return this.deltaValue[Object.keys(this.deltaValue)[0]].length === 2 && v !== false && v !== undefined && v !== null;
          }

          return false;
        },
        isRemoved(){
          if (typeof this.deltaValue === 'undefined') {
            return false
          }

          if (Array.isArray(this.deltaValue)) {
            return this.deltaValue.length === 2 && (this.deltaValue[1] === false || this.deltaValue[1] === undefined || this.deltaValue[1] === null);
          } else if (typeof this.deltaValue === 'object') {
            let v = this.deltaValue[Object.keys(this.deltaValue)[1]];
            return v && this.deltaValue[Object.keys(this.deltaValue)[1]].length === 2 && (v === false || v === undefined || v === null);
          }

          return false;
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/highlightChange.vue